export default "__VITE_ASSET__D2DbTCCK__"